import React from "react";
import NotFoundBlock from "../../components/NotFoundBlock/NotFoundBlock";

const NotFoundPage: React.FC = () => {
  return (
    <div className="container">
      <NotFoundBlock />
    </div>
  );
};

export default NotFoundPage;
